import React, { useState } from 'react'
import { IoMdArrowRoundBack } from "react-icons/io";
import { toAbsoluteUrl } from '../../../_helpers';
import { ImageExpandPopupCommon } from '../../widgets/tiles/ImageExpandPopupCommon';
import { VideoExpandPopupCommon } from '../../widgets/tiles/VideoExpandPopupCommon';
import SVG from "react-inlinesvg";
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import VideoIframe from '../../widgets/tiles/VideoIframe';
import { FaExternalLinkAlt, FaRegTrashAlt } from 'react-icons/fa';
import Availability from '../../popup/Availability';
import AdvancedTagSearch from '../../popup/AdvancedTagSearch';
import { Paper, Tab, Tabs, Typography } from "@material-ui/core";
import PropTypes from 'prop-types';
import { CopyUrlAlert } from '../../widgets/tiles/CopyURLAlert';
import CertificateLink from '../../popup/CertificateLink';


function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

export default function SearchDetail({from,stoneData,setDetailView,userinfo,updateAvailibility,removeStones,setDiamondSelected,diamondselected}) {
    const [value, setValue] = React.useState(0); // for tab
    const [showVideo, setShowVideo] = useState(false);
    const [showAssetImg, setShowAssetImg] = useState(false);
    const [showArrowImg, setShowArrowImg] = useState(false);
    const [showHeartImg, setShowHeartImg] = useState(false);
    const [heartBroken, setHeartBroken] = useState(false);
    const [arrowBroken, setArrowBroken] = useState(false);
    const [assetBroken, setAssetBroken] = useState(false);
    
        function handleTabChange(event, newValue) {
            setValue(newValue);
        }

        function numberWithCommas(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        function handleClose(event, reason) {
            setShowVideo(false);
            setShowHeartImg(false);
            setShowAssetImg(false);
            setShowArrowImg(false);
            setHeartBroken(false);
            setArrowBroken(false);
            setAssetBroken(false);
        }
    
        function openVideoModal() {
            setShowVideo(true)
        }
    
        function openHeartModal() {
            setShowHeartImg(true)
        }
    
        function openAssetModal() {
            setShowAssetImg(true)
        }
    
        function openArrowModal() {
            setShowArrowImg(true)
        }
    

  return (
    <>
        <div className={`card card-custom card-sticky product_detail gutter-b ${stoneData?.diamondType === "L" ? "labTab" : "natTab"} `}>
            <div className='card-body'>
                <div className="row">
                    <div className="col-12">
                        <div className='cursor-pointer search-backbutton' onClick={()=> setDetailView([])}><IoMdArrowRoundBack /> Back to result</div>
                    </div>
                    <div className="col-md-6 d-flex flex-lg-nowrap flex-wrap justify-content-center">
                        <div className="detail_img_box mt-4 order-lg-2 ribbon ribbon-top ribbon-left">
                            {stoneData?.diamondType === "N" || stoneData?.diamondType === "W" ? null: <div className="ribbon-target custom-top-ribbon lab-ribbon" style={{top:"-2px",right:"20px"}} >Lab</div> }
                            {stoneData?.image ? (
                                <img
                                    className="img-fluid"
                                    alt={stoneData?.shape}
                                    src={stoneData?.image}
                                    onError={e => {
                                        e.currentTarget.src = toAbsoluteUrl(
                                            `/media/shape/${stoneData?.shape ? stoneData?.shape.toLowerCase() : ""}-no.png`
                                            )
                                        }}
                                />
                            ) : (
                                <img
                                    className="img-fluid"
                                    alt="shape"
                                    src={toAbsoluteUrl(
                                        `/media/shape/${stoneData?.shape.toLowerCase()}-no.png`
                                    )}
                                    onError={e => {
                                        e.currentTarget.src = toAbsoluteUrl(
                                            `/media/General/NoDiamondImage.svg`
                                        )
                                    }}
                                />
                            )}
                        </div>
                        <ul className="img_thumb_box mt-4 ml-5 pl-0 d-flex d-lg-block order-lg-1">
                                <ImageExpandPopupCommon data={stoneData}/>
                                <VideoExpandPopupCommon  data={stoneData} userinfo={userinfo}/>
                                {stoneData?.heart ? (
                                    <li className="img_thumb cursor-pointer mr-md-0 mr-1" onClick={() => openHeartModal()}>
                                        <SVG  width="40" src={toAbsoluteUrl("/media/General/heartImage.svg")} />
                                        {/* <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-5.png"/> */}
                                    </li>
                                    
                                ):('')}
                                {stoneData?.arrow ? (
                                    <li className="img_thumb cursor-pointer mr-md-0 mr-1" onClick={() => openArrowModal()}>
                                        <SVG  width="40" src={toAbsoluteUrl("/media/General/arrowImage.svg")} />
                                        {/* <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-6.png"/> */}
                                    </li>
                                ):('')}
                                {stoneData?.asset ? (
                                    <li className="img_thumb cursor-pointer mr-md-0 mr-1" onClick={() => openAssetModal()}>
                                        <SVG  width="40" src={toAbsoluteUrl("/media/General/assetIcon.svg")} />
                                        {/* <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-3.png"/> */}
                                    </li>
                                ):('')}
                            </ul>
                    </div>
                    <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-8 my-3 d-flex justify-content-start align-items-center">
                                <div className=""><div className="d-inline-block"><Availability availability={stoneData?.availability}/>{stoneData.loatNo} <CopyUrlAlert text={stoneData?.loatNo}/></div>
                                </div>
                                  <div className="ml-md-10 ml-8" >
                                      {stoneData.certificate ? (
                                          <>

                                              <CertificateLink Certificate_link={stoneData.certificate_link} lab={stoneData.lab} certificate={stoneData.certificate} withExternalLinkIcon className={`mx-2 text-nowrap text-left`} />
                                              {stoneData.lab !== "NON" && <span><CopyUrlAlert text={stoneData.certificate} /></span>}
                                          </>

                                      ) : (
                                          ""
                                      )}
                                  </div>
                                    
                                    
                                </div>
                                <div className="col-md-10 align-self-center">
                                    <span className="text-dark font-weight-bold text-capitalize font-size-h3">
                                        <span className="pr-2 font-size-h2">
                                            {stoneData.shape}
                                        </span>
                                        <span className="pr-2 font-size-h2">
                                            {stoneData.carat.toFixed(2)}
                                        </span>
                                        <span className="pr-2 font-size-h2">{stoneData.color}</span>
                                        <span className="pr-2 font-size-h2">{stoneData.clarity}</span>
                                        <span className="pr-2 font-size-h2">{stoneData.cut}</span>
                                        <span className="pr-2 font-size-h2">{stoneData.polish}</span>
                                        <span className="pr-2 font-size-h2">{stoneData.symmetry}</span>
                                        <span className="pr-2 font-size-h2">{stoneData.fluorescence}</span>
                                    </span>
                                </div>
                                <div className='col-12'><AdvancedTagSearch {...stoneData}/></div>
                                <div className="col-12 mt-4 d-flex">
                                    <>
                                        <span className=""> 
                                            Location: {stoneData.location ? stoneData.location : ''}
                                            <img
                                                className="flagIco ml-2"
                                                alt={stoneData.location}
                                                src={toAbsoluteUrl(
                                                    `/media/map/${stoneData.location.toLowerCase()}.png`
                                                )}
                                                onError={e => {
                                                    e.currentTarget.src =toAbsoluteUrl(
                                                        `/media/map/other.png`
                                                        )
                                                    }}
                                            />
                                        </span>
                                    </>
                                </div>
                                <div className="col-12 mt-4 d-flex">
                                    <span className="font-size-lg text-dark-50"><span className="font-size-sm  text-capitalize">List Price: </span>${stoneData?.listPrice}</span>
                                </div>
                                <div className="col-12 mt-4">
                                    <div className="row">
                                        <div className="col-5">
                                            <div className="px-0">
                                                <h5 className="font-weight-bold">
                                                    Price
                                                </h5>
                                                <hr className="w-25 ml-0 my-2"/>
                                                    <div className={`d-flex small ${(stoneData?.supplierDiscount > 0) ? 'text-success' : 'text-danger'} align-items-center`}> {stoneData?.supplierDiscount ? `${stoneData?.supplierDiscount}% ${(stoneData?.supplierDiscount > 0) ? "PR" : "Off"}` : null}
                                                        <span className="ml-8 text-dark font-size-lg">(USD)</span>
                                                    </div>
                                                    <span className="h1">
                                                        <span className="small">$</span > <>{numberWithCommas(parseFloat((stoneData.supplierPrice )))}</>
                                                    </span>
                                                    <span className="d-flex small text-dark-50 align-items-center">Per Ct. <span className="font-size-sm text-dark-50 ml-2">${numberWithCommas(parseFloat(stoneData?.supplierRate))}</span></span>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {from === "list" ? 
                                <div className="col-12 mt-4">
                                    <button className="btn btn-primary btn-sm text-nowrap mr-2" onClick={()=>
                                            {
                                                updateAvailibility(diamondselected)
                                            }
                                        }><span className="mr-1"><SVG  width="15" src={toAbsoluteUrl("/media/General/updateStatus.svg")} /></span>Update Status</button>
                                    <OverlayTrigger placement="top" overlay={ <Tooltip id="tooltip"> Remove Stones </Tooltip> } >
                                        <button className="btn btn-danger btn-icon btn-sm text-nowrap mr-2" onClick={()=>{removeStones(diamondselected)}}><FaRegTrashAlt className="font-size-h5" /></button>
                                    </OverlayTrigger>
                                </div>
                                :
                                <div className="col-12 mt-4">
                                    <button className="btn btn-primary btn-sm text-nowrap mr-2" onClick={()=>
                                            {
                                                updateAvailibility([stoneData?.stockID])
                                                setDiamondSelected([stoneData])
                                            }
                                        }><span className="mr-1"><SVG  width="15" src={toAbsoluteUrl("/media/General/updateStatus.svg")} /></span>Update Status</button>
                                    <OverlayTrigger placement="top" overlay={ <Tooltip id="tooltip"> Remove Stones </Tooltip> } >
                                        <button className="btn btn-danger btn-icon btn-sm text-nowrap mr-2" onClick={()=>{removeStones([stoneData?.stockID]);setDiamondSelected([stoneData])}}><FaRegTrashAlt className="font-size-h5" /></button>
                                    </OverlayTrigger>
                                </div>
}
                                   
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div className={`card bg-white card-custom card-sticky gutter-b ${stoneData?.diamondType === "L" ? "labTab" : "natTab"}`}>
            <div className="card-header justify-content-center mb-3 min-card-header-height p-0">
                <div className="card-title m-0">
                    <Paper position="static" className="shadow-none">
                        <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleTabChange}>
                            <Tab label="Diamond Details" />
                            <Tab label="Parameter Details" />
                            <Tab label="Additional Details"/>
                        </Tabs>
                    </Paper>
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        {value === 0 && (
                            <TabContainer >
                                 <div className="row">
                                        <div className="col-md-4">
                                        <div className="row mb-2">
                                            <div className="col-6"> Stock ID </div>
                                            <div className="col-6 font-weight-bold">{stoneData?.loatNo}  </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6"> Shape </div>
                                            <div className="col-6 font-weight-bold">  {stoneData?.shape || "-"} </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6"> Carat </div>
                                            <div className="col-6 font-weight-bold"> {stoneData?.carat.toFixed(2) || "-"} </div>
                                        </div>
                                        
                                        { (stoneData?.color ==="fancy") ? (
                                            <>
                                                <div className="font-size-h5 text-dark font-weight-bold mb-3 ">Fancy Color Details </div>
                                                <div className="row mb-2">
                                                    <div className="col-6">Intensity</div>
                                                    <div className="col-6 font-weight-bold">  {stoneData.fancy_intensity ? stoneData.fancy_intensity : "-"} </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-6">Overtone</div>
                                                    <div className="col-6 font-weight-bold">  {stoneData.fancy_overtone ? stoneData.fancy_overtone : "-"} </div>
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-6">Fancy Color</div>
                                                    <div className="col-6 font-weight-bold">  {stoneData.fancy_color ? stoneData.fancy_color : "-"} </div>
                                                </div>
                                            </>
                                        ):(
                                            <div className="row mb-2">
                                                <div className="col-6">Color</div>
                                                <div className="col-6 font-weight-bold">  {stoneData.color ? stoneData.color : "-"} </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-4">
                                        <div className="row mb-2">
                                            <div className="col-6">Clarity</div>
                                            <div className="col-6 font-weight-bold">  {stoneData.clarity ? stoneData.clarity : "-"} </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">Cut</div>
                                            <div className="col-6 font-weight-bold">  {stoneData.cut ? stoneData.cut : "-"} </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">Polish</div>
                                            <div className="col-6 font-weight-bold">  {stoneData.polish ? stoneData.polish : "-"} </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6"> Symmetry </div>
                                            <div className="col-6 font-weight-bold">  {stoneData.symmetry ? stoneData.symmetry : "-"} </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="row mb-2">
                                            <div className="col-6"> Fluorescence</div>
                                            <div className="col-6 font-weight-bold">  {stoneData.fluorescence ? stoneData.fluorescence : "-"} </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">Lab</div>
                                            <div className="col-6 font-weight-bold">  {stoneData.lab ? stoneData.lab : "-"} </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">Certificate</div>
                                            <div className="col-6 font-weight-bold">
                                                <CertificateLink Certificate_link={stoneData.certificate_link} lab={stoneData.lab} certificate={stoneData.certificate} withExternalLinkIcon hideLabName className={`text-primary font-weight-bold`} />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-6">Location</div>
                                            <div className="col-6 font-weight-bold">  {stoneData.location ? stoneData.location : "-"} </div>
                                        </div>
                                       
                                    </div>
                                </div >
                            </TabContainer>
                        )}
                        {value === 1 && (
                            <TabContainer >
                                <div className="row">
                                        <div className="col-md-4">
                                            <div className="row mb-2">
                                                <div className="col-6">Measurement</div>
                                                <div className="col-6 font-weight-bold">  {stoneData?.length} * {stoneData.width} * {stoneData?.height}  </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6">Table %</div>
                                                <div className="col-6 font-weight-bold">  {stoneData.tablePercent} </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6">Depth %</div>
                                                <div className="col-6 font-weight-bold">  {stoneData.depthPercent} </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6">Crown</div>
                                                <div className="col-6 font-weight-bold">  {stoneData.crownHeight}, {stoneData.crownAngle}  </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row mb-2">
                                                <div className="col-6">Pavilion</div>
                                                <div className="col-6 font-weight-bold">  {stoneData.pavilionHeight}, {stoneData.pavilionAngle}  </div>
                                            </div>
                                            {stoneData.ratio && stoneData?.shape?.toLowerCase() !== 'round' ?(
                                                <div className="row mb-2">
                                                    <div className="col-6">Ratio</div>
                                                    <div className="col-6 font-weight-bold">  {stoneData.ratio}  </div>
                                                </div>
                                            ) : null }
                                            <div className="row mb-2">
                                                <div className="col-6">Girdle</div>
                                                <div className="col-6 font-weight-bold">   {stoneData.girdle ? stoneData.girdle : "-"}  </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6">Girdle Condition</div>
                                                <div className="col-6 font-weight-bold">   {stoneData.girdleCondition ? stoneData.girdleCondition : "-"}  </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6">Girdle Thick</div>
                                                <div className="col-6 font-weight-bold">   {stoneData.girdle_thick ? stoneData.girdle_thick : "-"}  </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6">Girdle Thin</div>
                                                <div className="col-6 font-weight-bold">   {stoneData.girdle_thin ? stoneData.girdle_thin : "-"}  </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row mb-2">
                                                <div className="col-6">Culet</div>
                                                <div className="col-6 font-weight-bold">   {stoneData.culet ? stoneData.culet : "-"}  </div>
                                            </div>
                                           
                                        </div>
                                    </div>

                            </TabContainer>
                        )}
                        {value === 2 && (
                            <TabContainer >
                                <div className="row">
                                        <div className="col-md-4">
                                            <div className="row mb-2">
                                                <div className="col-6"> Shade</div>
                                                <div className="col-6 font-weight-bold">  {stoneData.shade ? stoneData.shade : "-"} </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-6"> Milky </div>
                                                <div className="col-6 font-weight-bold">  {stoneData.milky ? stoneData.milky : "-"} </div>
                                            </div>
                                            <div className="row mb-2"> 
                                                <div className="col-6"> Eye clean </div>
                                                <div className="col-6 font-weight-bold">  {stoneData.eyeClean ? stoneData.eyeClean : "-"} </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            {stoneData.diamondType === "L" ? 
                                                <>
                                                    <div className="row mb-2">
                                                        <div className="col-6"> Growth Type </div>
                                                        <div className="col-6 font-weight-bold">  {stoneData.growthType ? stoneData.growthType : "-"} </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-6"> Treatment </div>
                                                        <div className="col-6 font-weight-bold">  {stoneData.lab_treat === "Treated"?"Post Growth Treatment": stoneData.lab_treat?stoneData.lab_treat : "-"} </div>
                                                    </div>
                                                </>
                                            :   
                                                <>
                                                    <div className="row mb-2">
                                                        <div className="col-6"> Origin </div>
                                                        <div className="col-6 font-weight-bold">  {stoneData.origin ? stoneData.origin : "-"} </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-6"> Brand </div>
                                                        <div className="col-6 font-weight-bold">  {stoneData.brand ? stoneData.brand : "-"} </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-6"> Treatment </div>
                                                        <div className="col-6 font-weight-bold">  {stoneData.treatment ? stoneData.treatment : "-"} </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row mb-2"> 
                                                <div className="col-6"> Key to symbol </div>
                                                <div className="col-6 font-weight-bold">  {stoneData.keyToSymbol ? stoneData.keyToSymbol : "-"} </div>
                                            </div>
                                        </div>
                                    </div>
                            </TabContainer>
                        )}
                    </div>
                </div>
            </div>
        </div>
        <Modal
            show={showHeartImg}
            onHide={handleClose}
            size="lg"
        >
            <Modal.Body className="text-center">
                {heartBroken ?
                    <img  src={toAbsoluteUrl(`/media/General/NoDiamondImage.svg`)} height="300px" width="300px" alt={stoneData?.shape} className="img-fluid bg-light rounded" />
                :
                    <img 
                        src={`${stoneData?.heart}`}
                        alt={stoneData?.shape}
                        onError={
                            ()=>
                                setHeartBroken(true)
                        }
                        className="img-fluid" />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal
            show={showArrowImg}
            onHide={handleClose}
            size="lg"
        >
            <Modal.Body className="text-center">
                {arrowBroken ?
                    <img  src={toAbsoluteUrl(`/media/General/NoDiamondImage.svg`)} height="300px" width="300px" alt={stoneData?.shape} className="img-fluid bg-light rounded" />
                :
                    <img 
                        src={stoneData?.arrow}
                        alt={stoneData?.shape} 
                        onError={()=> setArrowBroken(true)}
                        className="img-fluid"
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal
            show={showAssetImg}
            onHide={handleClose}
            size="lg"
        >
            <Modal.Body className="text-center">
                {assetBroken ?
                    <img  src={toAbsoluteUrl(`/media/General/NoDiamondImage.svg`)} height="300px" width="300px" alt={stoneData?.shape} className="img-fluid bg-light rounded" />
                :
                    <img src={`${stoneData?.asset}`} alt={stoneData?.shape}  onError={()=> setAssetBroken(true)}  className="img-fluid" />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                Close
                </Button>
            </Modal.Footer>
        </Modal>
        <VideoIframe
            showVideo={showVideo}
            handleClose={handleClose}
            src={stoneData?.video }
        />
    </>
  )
}
